import Vue from 'vue';
import { recommendMcAttrByAIAndData } from '../../api/recommendMcAttr';
import { searchSimilarityCspuByName } from '../../api/similarityCspu';
import { hasMarketingWordSymbol } from './utils';

/**
 * 查找相似度满足一定诉求的 CSPU Name
 */
export async function getSimilarCSPUNameWithMarketingWord(name, similarity = 0.9) {
    if (!name) return [];
    const similars = await searchSimilarityCspuByName(name);
    if (!similars?.length) return [];
    const similarNamesWithMarketingWord = similars
        .filter((cspu) => parseFloat(cspu.similarity) >= similarity) // 相似度 > 90%
        .filter((cspu) => hasMarketingWordSymbol(cspu?.cspuWithAttr?.cspuName)) // 携带营销词
        .map((cspu) => cspu?.cspuWithAttr?.cspuName);
    return similarNamesWithMarketingWord;
}

/**
 * 根据商品名，获取推荐类目
 * @param {*} params
 * @param {*} params.skuName 商品名
 * @param {*} params.bgCategoryId 当前选中类目 id
 * @param {*} params.bgCategoryName 当前选中类目名
 * @param {*} callbacks
 * @param {*} callbacks.onConfirmShow 当用户选择和系统推荐类目不一致时，展示推荐类目弹窗时的回调函数
 * @param {*} callbacks.onOK 当用户选择和系统推荐类目不一致时，用户确认选择系统推荐，回调函数
 * @param {*} callbacks.onCancel 当用户选择和系统推荐类目不一致时，用户不选择系统推荐，回调函数
 */
export async function useRecommendAttr(params, callbacks) {
    const { skuName, bgCategoryId, bgCategoryName } = params || {};
    const {
        onConfirmShow,
        onOK,
        onCancel,
        onLoaded,
    } = callbacks || {};

    const res = await recommendMcAttrByAIAndData(skuName, bgCategoryId);
    // 1.recommendMcSku中的skuExtAttrList字段是扩展属性的推荐值，针对的扩展属性目前只有销售规格和基础属性。
    // 2.城市售卖属性、城市采购属性类型的扩展属性短期内不会接入，运营内容属性的扩展属性处于废弃状态，也不会接入。
    // => 只需要在“提报信息”和“商品基本信息”中接入扩展属性的推荐值。结论 from jiawei12
    const recommendValueObj = res.recommendMcSku || {};

    // eslint-disable-next-line no-unused-expressions
    typeof onLoaded === 'function' && onLoaded(res);

    if (bgCategoryId && recommendValueObj.bgCategoryId && recommendValueObj.bgCategoryId !== bgCategoryId) {
        // eslint-disable-next-line no-unused-expressions
        typeof onConfirmShow === 'function' && onConfirmShow();
        Vue.prototype.$mc.confirm({
            title: '提醒',
            message: `当前填写的后台类目：<span style="color:#00b85c">${bgCategoryName}</span><br/>
                    系统推荐后台类目：<span style="color:#00b85c">${recommendValueObj.bgCategoryName}</span><br/>
                    存在<span style="color:#ff363f">不一致</span>，请检查填写是否正确`,
            width: '430px',
            showCancelButton: true,
            dangerouslyUseHTMLString: true,
            closable: false,
            okButtonText: '填写错误，按推荐修改',
            cancelButtonText: '填写正确，无需修改',
            onOk: async () => {
                // eslint-disable-next-line no-unused-expressions
                typeof onOK === 'function' && onOK(res);
            },
        }).catch(() => {
            // eslint-disable-next-line no-unused-expressions
            typeof onCancel === 'function' && onCancel(res);
        });
    }
}
